<template>
    <widget
        :title="$tc('phrases.smsHistory') + ' (' + smses.length + ')' "
        color="green"
        :subscriber="subscriber"
        :button="true"
        :empty-state-create-button="true"
        @widgetAction="hideEmptyStateArea"
    >
        <div>
            <md-content class="md-scrollbar chat-body chat-body-scroll" ref="chat" id="chat-body">
                <md-list class="md-triple-line sms-history-list">
                    <md-list-item
                        v-for="sms in smses"
                        :key="sms.id"
                        class="md-scrollbar sms-history-item"
                        :class="sms.direction === 0 ? 'incoming' : 'outgoing'">
                        <md-icon v-if="sms.direction !== 0">textsms</md-icon>
                        <md-icon v-else>mark_email_unread</md-icon>

                        <div class="md-list-item-text md-size-100">
                            <div class="md-layout">
                                <div class="md-layout-item md-gutter md-size-100 sms-meta">
                                    <div class="md-layout-item md-size-5" style="float:left; font-weight: bold;">
                                        <small>
                                            <md-icon>person</md-icon>
                                        </small>
                                    </div>
                                    <div class="md-layout-item md-size-95 sms-sender">
                                        <a v-if="sms.direction === 0 " href="javascript:void(0);"
                                           class="username">{{ personName }}</a>
                                        <a v-else href="javascript:void(0);" class="username">{{
                                                $tc('words.system')
                                            }}</a>
                                    </div>
                                </div>
                                <div class="md-layout-item md-size-100 sms-meta">
                                    <span><small>{{ formatDate(sms.created_at) }} - {{
                                            getTimeAgo(sms.created_at)
                                        }}
                                        <span v-if="smsStatusLabel(sms)"
                                              class="sms-status-label"
                                              :class="smsStatusClass(sms)">
                                            {{ smsStatusLabel(sms) }}
                                        </span>
                                    </small></span>
                                    <md-button
                                        v-if="canResendSms(sms)"
                                        class="md-dense md-raised md-accent sms-resend-button"
                                        :disabled="resendingId === sms.id"
                                        @click="resendSms(sms)"
                                    >
                                        {{ $tc('words.resend') }}
                                    </md-button>
                                </div>
                                <div class="md-layout-item md-size-100">
                                    <div class="sms-message-box" :class="smsStatusClass(sms)">
                                        <p style="white-space: pre-line; margin: 0;">{{ sms.body }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </md-list-item>
                </md-list>
                <div class="md-layout md-gutter md-size-100" style="margin: 2vh">
                    <div class="md-layout-item md-size-100">
                        <md-field>
                            <md-textarea :placeholder="$tc('phrases.writeMessage')" v-model="message"></md-textarea>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <div class="container">
                            <div class="content"></div>
                            <md-button type="submit" class="md-primary md-raised md-alignment-center-right"
                                       @click="sendSms">{{ $tc('words.send') }}
                            </md-button>
                        </div>
                    </div>
                </div>


            </md-content>
        </div>

    </widget>
</template>

<script>
import Widget from '../../shared/widget'
import { EventBus } from '@/shared/eventbus'
import moment from 'moment'
import { SmsService } from '@/services/SmsService'
import { smsStatus } from '@/mixins/smsStatus'
import { mapGetters } from 'vuex'

export default {
    name: 'SmsHistory',
    components: { Widget },
    mixins: [smsStatus],
    props: {
        personId: {
            type: String,
            required: true
        },
        personName: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            authUser: 'auth/getAuthenticateUser',
        })
    },
    mounted () {
        this.getSmsList()
    },
    data () {
        return {
            smsService: new SmsService(),
            smses: [],
            message: '',
            subscriber: 'customer-sms-history',
            resendingId: null,
        }
    },
    methods: {
        hideEmptyStateArea () {
            EventBus.$emit('hideEmptyStateArea', this.subscriber)
        },
        getTimeAgo (date) {
            return moment(date).fromNow()

        },
        formatDate (date) {
            let d = new Date(date)
            return d.toLocaleDateString()
        },
        getSmsList () {
            this.smsService.getList(this.personId).then(response => {
                this.smses = response
                EventBus.$emit('widgetContentLoaded', this.subscriber, this.smses.length)
                if (this.smses.length) {
                    this.scrollDown()
                }

            })
        },
        async sendSms () {
            if (this.message.length <= 3) {
                this.alertNotify('warn', this.$tc('phrases.messageNotify'))
                return
            }
            try {
                const { data: { data } } = await this.smsService.sendToPerson(this.message, this.personId, this.authUser.id)
                this.alertNotify('success', this.$tc('words.successful'))
                this.smses.push(data)
                this.message = ''
                this.scrollDown()
            } catch (e) {
                console.log(e)
            }

        },
        async resendSms (sms) {
            try {
                this.resendingId = sms.id
                const updatedSms = await this.smsService.resend(sms.id)
                if (updatedSms && updatedSms.id) {
                    sms.status = updatedSms.status
                    this.alertNotify('success', this.$tc('phrases.smsResendNotify'))
                } else {
                    this.alertNotify('error', updatedSms.message || this.$tc('phrases.somethingWentWrong'))
                }
            } catch (e) {
                this.alertNotify('error', e.message)
            } finally {
                this.resendingId = null
            }
        },

        scrollDown () {
            let parent = this
            setTimeout(function () {
                let chat = parent.$refs.chat
                chat.scrollTop = chat.scrollHeight
            }, 1000)
        },
        alertNotify (type, message) {
            this.$notify({
                group: 'notify',
                type: type,
                title: type + ' !',
                text: message
            })
        },

    }
}
</script>

<style scoped>

.md-content {
    max-height: 400px;
    overflow: auto;
}

.sms-sender {
    float: right;
    font-weight: bolder;
    margin-top: 5px;
}

.chat-body-scroll {
    overflow-y: scroll !important;
}

.sms-history-list {
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    border: none;
    background: transparent;
}

.sms-history-item {
    margin-bottom: 12px;
    padding: 8px 4px !important;
    background: transparent !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.sms-meta {
    margin-bottom: 6px;
}

.sms-message-box {
    padding: 10px 14px;
    border-radius: 14px;
    margin-top: 4px;
    display: inline-block;
    max-width: 100%;
}

.sms-status-incoming {
    background-color: #BBDEFB;
}

.sms-status-failed {
    background-color: #FFCDD2;
}

.sms-status-pending {
    background-color: #FFF9C4;
}

.sms-status-sent {
    background-color: #C8E6C9;
}

.sms-status-label {
    margin-left: 8px;
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 600;
}

.sms-resend-button {
    margin-left: 8px;
    min-width: auto !important;
    height: 28px !important;
}

.container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
}

.content {
    flex-grow: 1;
}
</style>
